import { FilterPathNode, FilterPathRootNode } from '../models';

export function getNodes(node: FilterPathNode | FilterPathRootNode): FilterPathNode[] {
  const result = node.relatedNodes;
  const subNodes = result.map(getNodes);

  return result.concat(result, ...subNodes);
}
